module.exports = __webpack_public_path__ + "img/marker-icon-red.5d07a58e.png";